<template>
  <Select
    :items="statuses"
    :selectedItem="filter.status"
    :label="$i18n('cortina_marketings.index.status')"
    :searchPlaceholder="$i18n('cortina_marketings.filtro.buscar_status')"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :filtro_default="filtro.default"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';

const STATUS_IDS = ['ativa', 'agendada', 'expirada'];

export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      filter: {
        status: {
          id: '',
          name: '',
        },
      },
    };
  },
  computed: {
    statuses() {
      return STATUS_IDS.map(id => ({
        id,
        name: this.$i18n(`cortina_marketings.index.status_${id}`),
      }));
    },
  },
  methods: {
    atualizar(status) {
      this.filter.status = status;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.status.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.status.id,
      });
    },
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.statuses, this.filter.status);
  },
}
</script>
